export default {
  "nav.home": "Inicio",
  "nav.guide": "Guía de compra",
  "nav.browse": "Explorar categorías",
  "brand.tagline": "Recurso USFans Spreadsheet",
  "brand.subtag": "Recurso independiente",

  "cta.spreadsheet": "USFans Spreadsheet",
  "cta.buyNow": "Comprar ahora",
  "cta.explore": "Explorar el Spreadsheet de USFans",
  "cta.browse": "Explorar categorías",
  "cta.main": "Ir al sitio principal",

  "dropdown.label": "Ir a una categoría",
  "dropdown.placeholder": "Elige una categoría…",

  "category.shoes": "Zapatos",
  "category.hoodies": "Sudaderas/Sweaters",
  "category.tshirts": "Camisetas",
  "category.jackets": "Chaquetas",
  "category.pants": "Pantalones/Shorts",
  "category.headwear": "Gorros",
  "category.sets": "Conjuntos",
  "category.underwear": "Ropa interior/Calzoncillos",
  "category.jersey": "Camisetas deportivas",
  "category.accessories": "Accesorios",
  "category.bags": "Bolsos",
  "category.belts": "Cinturones",
  "category.perfumes": "Perfumes",
  "category.other": "Otros artículos",

  "categoryDesc.shoes": "Zapatillas, calzado casual y deportivo.",
  "categoryDesc.hoodies": "Sudaderas con y sin capucha.",
  "categoryDesc.tshirts": "Camisetas de manga corta y larga.",
  "categoryDesc.jackets": "Abrigos para cada temporada.",
  "categoryDesc.pants": "Vaqueros, chinos y pantalones cortos.",
  "categoryDesc.headwear": "Gorras, sombreros y gorros.",
  "categoryDesc.sets": "Conjuntos coordinados a juego.",
  "categoryDesc.underwear": "Ropa interior y básicos.",
  "categoryDesc.jersey": "Camisetas deportivas y de equipo.",
  "categoryDesc.accessories": "Relojes y pequeños complementos.",
  "categoryDesc.bags": "Mochilas, bolsos y totes.",
  "categoryDesc.belts": "Cinturones de cuero y casuales.",
  "categoryDesc.perfumes": "Fragancias para hombre y mujer.",
  "categoryDesc.other": "Miscelánea y novedades.",

  "footer.about": "usfanslink.lol es un recurso informativo independiente sobre el Spreadsheet de USFans. No estamos afiliados a USFans.",
  "footer.disclaimer": "Aviso legal",
  "footer.disclaimerText": "Este sitio es un recurso informativo independiente y no está necesariamente afiliado a USFans.",
  "footer.quickLinks": "Enlaces rápidos",
  "footer.rights": "Todos los derechos reservados.",
};